// Logique pure du calendrier des événements (lot L5-C1, M21) : bornes d'un mois, grille des semaines (lundi
// en premier), événements d'un jour à l'heure de Libreville, tons des états, montants en francs CFA.
import { ETATS_EVENEMENT, type EtatEvenement, type ResumeEvenement } from '@cc/contrats';
import type { TonEtat } from '@cc/ui';

export const TON_EVENEMENT: Record<EtatEvenement, TonEtat> = { en_preparation: 'attente', publie: 'signer', tenu: 'ok', annule: 'neutre' };
export const libelleEvenement = (e: EtatEvenement) => ETATS_EVENEMENT[e];

const deux = (n: number) => String(n).padStart(2, '0');

/** Jour civil (AAAA-MM-JJ) d'un instant, à l'heure de Libreville (UTC + 1, sans heure d'été). */
export function jourLibreville(iso: string): string {
  return new Date(new Date(iso).getTime() + 3_600_000).toISOString().slice(0, 10);
}

/** Premier et dernier jour du mois (AAAA-MM). */
export function bornesMois(mois: string): { du: string; au: string } {
  const [a, m] = mois.split('-').map(Number) as [number, number];
  const dernier = new Date(Date.UTC(a, m, 0)).getUTCDate();
  return { du: `${mois}-01`, au: `${mois}-${deux(dernier)}` };
}

export function moisDecale(mois: string, n: number): string {
  const [a, m] = mois.split('-').map(Number) as [number, number];
  const d = new Date(Date.UTC(a, m - 1 + n, 1));
  return `${d.getUTCFullYear()}-${deux(d.getUTCMonth() + 1)}`;
}

/** Semaines du mois (lundi à dimanche) ; null pour les cases hors du mois. */
export function grilleMois(mois: string): (string | null)[][] {
  const { du, au } = bornesMois(mois);
  const premier = new Date(`${du}T12:00:00Z`).getUTCDay();
  const decalage = (premier + 6) % 7;
  const total = Number(au.slice(8));
  const cases: (string | null)[] = [...Array<null>(decalage).fill(null), ...Array.from({ length: total }, (_, i) => `${mois}-${deux(i + 1)}`)];
  while (cases.length % 7 !== 0) cases.push(null);
  const semaines: (string | null)[][] = [];
  for (let i = 0; i < cases.length; i += 7) semaines.push(cases.slice(i, i + 7));
  return semaines;
}

/** Événements qui occupent un jour (du jour de début au jour de fin inclus). */
export function evenementsDuJour(liste: ResumeEvenement[], jour: string): ResumeEvenement[] {
  return liste.filter((e) => jourLibreville(e.debut) <= jour && jour <= jourLibreville(e.fin));
}

export const montantFcfa = (n: number | null, fictif: boolean) => (n === null ? 'Non renseigné' : `${n.toLocaleString('fr-FR')} F CFA${fictif ? ' (fictif)' : ''}`);
